export interface InsightsGroupSearchFilter {
  page_size: number;
  page: number;
  query: string;
  collection: 'groups' | 'team-members';
}

export interface InsightsGlobalFilters {
  start_date?: string;
  end_date?: string;
  group_ids?: string[];
  group_collection_id?: string;
}

export interface InsightsGraph {
  name: string;
  series: InsightsGraphSeries[];
}

export interface InsightsGraphSeries {
  name: string;
  value: string;
}

export interface InsightsCsvExportParams extends InsightsGlobalFilters {
  report_name: InsightsCsvReportName;
  influencer_name?: string;
  channels?: string[];
  group_ids?: string[];
  referral_click_benchmark_value?: number;
}

export enum InsightsCsvReportName {
  CREDENTIAL_ENGAGEMENT = 'credential_engagement',
  RECIPIENT_ACTIVITY = 'recipient_activity',
  INFLUENCERS = 'influencers',
  MARKETING_ROI = 'marketing_roi',
}

export interface InsightsCsvExportResponse {
  success: boolean;
  filename: string;
}

export interface InsightsCsvExportStatusResponse {
  status: 'inprogress' | 'completed';
  url: string;
}

export enum InsightsGroupingTimePeriod {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  QUARTERLY = 'quarterly',
  YEARLY = 'yearly',
}
